import { fromJS } from 'immutable';
import * as actions from '../actions/global';
import { fetchingState, menuData } from '@constants';

const { START, SUCCESS, ERROR } = actions;
const initialStats = {
  appraisers: {},
  currentAppraisalYear: '2020',
  preference: {},
  selectedYear: '2020',
  selectedOwnerRecord: '',
  selectedAgentRecord: '',
  selectedDeedRecord: '',
  selectedMortgagelenderRecord: '',
  selectedWebpageRecord: '',
  selectedPropertyRecord: '',
  selectedPropertyRecordYear: '',
  selectedPropertyPVersion: '',
  selectedPropertyPRollCorr: '',
  selectedSmartGroupRecord: '',
  selectedBuilderPlanRecord: '',
  selectedEconomicUnitRecord: '',
  selectedEconomicUnitYear: '',
  selectedEconomicUnitVersion: '',
  selectedEconomicUnitRollCorr: '',
  quickSearchFlag: false,
  isMenuVisible: false,
  sideMenu: menuData.appraisal,
  propertyTypes: {},
  roles: {},
  years: { state: null, data: [] },
  appraisalCompanies: { data: [], state: null },
  assignmentPath: {},
  econNavData: {},
  viewOnly: false,
};

export default (state = fromJS(initialStats), action) => {
  let newState;
  switch (action.type) {
    case actions.PREFERENCE_FETCH_START:
      return state.setIn(['preference', 'state'], fetchingState.FETCHING);
    case actions.PREFERENCE_FETCH_SUCCESS:
      newState = state.setIn(['preference', 'state'], fetchingState.LOADED);
      return newState.setIn(
        ['preference', 'data'],
        fromJS(
          action.data.results.length > 0
            ? action.data.results[0].preference
            : {},
        ),
      );
    case actions.PREFERENCE_FETCH_ERROR:
      return state.setIn(['preference', 'state'], fetchingState.ERROR);

    case actions.PREFERENCE_PERSIST_SUCCESS:
      newState = state.setIn(['preference', 'state'], fetchingState.LOADED);
      return newState.setIn(
        ['preference', 'data'],
        fromJS(
          action.data.results.length > 0
            ? action.data.results[0].preference
            : {},
        ),
      );
    case actions.SET_QUICK_SEARCH_FLAG:
      return state.setIn(
        ['quickSearchFlag'],
        !state.getIn(['quickSearchFlag']),
      );
    case actions.SELECT_YEAR:
      return state.set('selectedYear', action.data);

    // case actions.CURRENT_APPRAISAL_YEAR_FETCH[START]:
    //   return state.setIn([ 'currentAppraisalYear', 'state' ], fetchingState.FETCHING);
    case actions.CURRENT_APPRAISAL_YEAR_FETCH[SUCCESS]:
      return state.set(
        'currentAppraisalYear',
        action.data.results.year.toString(),
      );
    // case actions.CURRENT_APPRAISAL_YEAR_FETCH[ERROR]:
    //   return state.setIn([ 'currentAppraisalYear', 'state' ], fetchingState.ERROR);

    case actions.SELECT_OWNER_RECORD:
      return state.merge({
        selectedOwnerRecord: action.data,
        selectedAgentRecord: '',
        selectedDeedRecord: '',
        selectedMortgagelenderRecord: '',
        selectedPropertyRecord: '',
        selectedPropertyRecordYear: '',
        selectedSmartGroupRecord: '',
        selectedBuilderPlanRecord: '',
        selectedEconomicUnitRecord: '',
      });
    case actions.SELECT_AGENT_RECORD:
      return state.merge({
        selectedOwnerRecord: '',
        selectedAgentRecord: action.data,
        selectedDeedRecord: '',
        selectedMortgagelenderRecord: '',
        selectedPropertyRecord: '',
        selectedPropertyRecordYear: '',
        selectedSmartGroupRecord: '',
        selectedBuilderPlanRecord: '',
        selectedEconomicUnitRecord: '',
      });
    case actions.SELECT_DEED_RECORD:
      return state.merge({
        selectedOwnerRecord: '',
        selectedAgentRecord: '',
        selectedDeedRecord: action.data,
        selectedMortgagelenderRecord: '',
        selectedPropertyRecord: '',
        selectedSmartGroupRecord: '',
        selectedBuilderPlanRecord: '',
        selectedEconomicUnitRecord: '',
      });
    case actions.SELECT_MORTGAGELENDER_RECORD:
      return state.merge({
        selectedOwnerRecord: '',
        selectedAgentRecord: '',
        selectedDeedRecord: '',
        selectedMortgagelenderRecord: action.data,
        selectedPropertyRecord: '',
        selectedPropertyRecordYear: '',
        selectedSmartGroupRecord: '',
        selectedBuilderPlanRecord: '',
        selectedEconomicUnitRecord: '',
      });
    case actions.SELECT_WEBPAGE_RECORD:
      return state.set('selectedWebpageRecord', action.data);
    case actions.SET_VIEW_ONLY_MODE:
      return state.merge({
        viewOnly: true,
      });
    case actions.SELECT_PROPERTY_RECORD:
      return state.merge({
        selectedOwnerRecord: '',
        selectedAgentRecord: '',
        selectedDeedRecord: '',
        selectedMortgagelenderRecord: '',
        selectedPropertyRecord: action.data,
        selectedSmartGroupRecord: '',
        selectedBuilderPlanRecord: '',
        selectedEconomicUnitRecord: '',
      });
    case actions.SELECT_SMART_GROUP_RECORD:
      return state.merge({
        selectedOwnerRecord: '',
        selectedAgentRecord: '',
        selectedDeedRecord: '',
        selectedMortgagelenderRecord: '',
        selectedPropertyRecord: '',
        selectedBuilderPlanRecord: '',
        selectedEconomicUnitRecord: '',
        selectedSmartGroupRecord: action.data,
      });
    case actions.SELECT_BUILDER_PLAN_RECORD:
      return state.merge({
        selectedOwnerRecord: '',
        selectedAgentRecord: '',
        selectedDeedRecord: '',
        selectedMortgagelenderRecord: '',
        selectedPropertyRecord: '',
        selectedSmartGroupRecord: '',
        selectedEconomicUnitRecord: '',
        selectedBuilderPlanRecord: action.data,
      });
    case actions.SELECT_ECONOMIC_UNIT_RECORD:
      return state.merge({
        selectedOwnerRecord: '',
        selectedAgentRecord: '',
        selectedDeedRecord: '',
        selectedMortgagelenderRecord: '',
        selectedPropertyRecord: '',
        selectedSmartGroupRecord: '',
        selectedBuilderPlanRecord: '',
        selectedEconomicUnitRecord: action.data,
      });
    case actions.SELECT_PROPERTY_RECORD_YEAR:
      return state.set('selectedPropertyRecordYear', action.data);

    case actions.SELECT_PROPERTY_RECORD_DETAILS:
      return state.merge({
        selectedPropertyPVersion: action.data.pVersion,
        selectedPropertyPRollCorr: action.data.pRollCorr,
      });

    case actions.SELECT_ECONOMIC_UNIT_RECORD_DETAILS:
      return state.merge({
        selectedEconomicUnitYear: action.data.pYear,
        selectedEconomicUnitVersion: action.data.pVersion,
        selectedEconomicUnitRollCorr: action.data.pRollCorr,
      });

    case actions.PROPERTYTYPES_FETCH[START]:
      return state.setIn(['propertyTypes', 'state'], fetchingState.FETCHING);
    case actions.PROPERTYTYPES_FETCH[SUCCESS]:
      newState = state.setIn(['propertyTypes', 'state'], fetchingState.LOADED);
      return newState.setIn(
        ['propertyTypes', 'data'],
        fromJS(action.data ? action.data.results : []),
      );
    case actions.PROPERTYTYPES_FETCH[ERROR]:
      return state.setIn(['propertyTypes', 'state'], fetchingState.ERROR);

    case actions.ROLES_FETCH[START]:
      return state.setIn(['roles', 'state'], fetchingState.FETCHING);
    case actions.ROLES_FETCH[SUCCESS]:
      newState = state.setIn(['roles', 'state'], fetchingState.LOADED);
      return newState.setIn(
        ['roles', 'data'],
        fromJS(action.data ? action.data.results : []),
      );
    case actions.ROLES_FETCH[ERROR]:
      return state.setIn(['propertrolesyTypes', 'state'], fetchingState.ERROR);

    case actions.TOGGLE_MENU:
      return state.set('isMenuVisible', !state.get('isMenuVisible'));

    case actions.SELECT_ASSIGNMENT_PATH:
      return state.set('assignmentPath', fromJS(action.data));

    case actions.SET_SIDEBAR_MENU:
      return state.set('sideMenu', fromJS(action.data));

    case actions.APPRAISAL_YEARS_FETCH[START]:
      return state.setIn(['years', 'state'], fetchingState.FETCHING);
    case actions.APPRAISAL_YEARS_FETCH[SUCCESS]:
      newState = state.setIn(['years', 'state'], fetchingState.LOADED);
      return newState.setIn(
        ['years', 'data'],
        fromJS(action.data ? action.data.results : []),
      );
    case actions.APPRAISAL_YEARS_FETCH[ERROR]:
      return state.setIn(['years', 'state'], fetchingState.ERROR);

    case actions.APPRAISERS_FETCH[START]:
      return state.setIn(['appraisers', 'state'], fetchingState.FETCHING);
    case actions.APPRAISERS_FETCH[SUCCESS]:
      newState = state.setIn(['appraisers', 'state'], fetchingState.LOADED);
      return newState.setIn(
        ['appraisers', 'data'],
        fromJS(action.data ? action.data.results : []),
      );
    case actions.APPRAISERS_FETCH[ERROR]:
      return state.setIn(['appraisers', 'state'], fetchingState.ERROR);

    case actions.APPRAISAL_COMPANIES_FETCH[START]:
      return state.setIn(
        ['appraisalCompanies', 'state'],
        fetchingState.FETCHING,
      );
    case actions.APPRAISAL_COMPANIES_FETCH[SUCCESS]:
      newState = state.setIn(
        ['appraisalCompanies', 'state'],
        fetchingState.LOADED,
      );
      return newState.setIn(
        ['appraisalCompanies', 'data'],
        fromJS(action.data ? action.data.results : []),
      );
    case actions.APPRAISAL_COMPANIES_FETCH[ERROR]:
      return state.setIn(['appraisalCompanies', 'state'], fetchingState.ERROR);

    case actions.SET_ECON_NAV_DATA:
      return state.setIn(['econNavData'], fromJS(action.data));

    default:
      return state;
  }
};
